import type { NavigationServicePrepareQueryParamsConfig } from '@/services/NavigationService/types/NavigationServicePrepareQueryParamsConfig';
import type { NavigateFunction } from 'react-router-dom';

class NavigationService {
  private static navigate: NavigateFunction | null = null;

  static setNavigate(navigateFunction: NavigateFunction | null) {
    this.navigate = navigateFunction;
  }

  static getNavigate() {
    if (!this.navigate) return null;
    return this.navigate;
  }

  static navigateTo(path: string, options?: any) {
    const navigate = this.getNavigate();
    if (navigate) navigate(path, options);
    else location.href = path;
  }

  static prepareQueryParams({ withPrefix = [], withoutPrefix }: NavigationServicePrepareQueryParamsConfig): string {
    const searchParams = new URLSearchParams();

    if (withPrefix?.length) {
      withPrefix.forEach(({ prefix, params }) => {
        if (Object.keys(params)?.length) {
          Object.keys(params).forEach((paramKey) => {
            if (!params[paramKey].length) return;
            const formattedParamKey = [prefix, paramKey].filter(Boolean).join('-');
            searchParams.set(formattedParamKey, params[paramKey].join(','));
          });
        }
      });
    }

    if (withoutPrefix?.params && Object.keys(withoutPrefix.params)?.length) {
      Object.keys(withoutPrefix.params).forEach((paramKey) => {
        if (!withoutPrefix.params[paramKey].length) return;
        searchParams.set(paramKey, withoutPrefix.params[paramKey].join(','));
      });
    }

    return searchParams.toString();
  }
}

export default NavigationService;
